<template>
  <div class="page page-supply-info-face input-page">
    <div class="info-list">
      <div class="info-title">
        <div class="line"></div>
        <div class="txt">上传照片</div>
      </div>
      <div class="face-img">
        <div class="left">
          <div class="txt1">人脸正面照</div>
          <div class="txt2">请拍照采集人脸图片</div>
        </div>
        <img
          class="img"
          v-if="liveImage"
          @click="chooseImage"
          :src="liveImage"
        />
        <img
          class="img"
          v-else
          @click="chooseImage"
          src="~@/assets/img/img_people.png"
        />
      </div>
      <div class="tips-txt">需采集您的人脸信息以核实身份</div>
      <img class="tips-img" src="~@/assets/img/img_requirements.png" />
    </div>
    <!-- 提交按钮 -->
    <div class="homecustom-btn">
      <van-button
        type="primary"
        :color="canSubmit ? '#FFA543' : '#FFCE98'"
        @click="onSubmit"
        block
      >
        提交
      </van-button>
    </div>
    <van-toast id="van-toast" />
    <van-dialog confirm-button-color="#5280FE" id="van-dialog" />
  </div>
</template>

<script>
import { faceVerification } from '@/api/common'
import { chooseImage } from '@/common/oss'

export default {
  data() {
    return {
      liveImage: '',
      signInfo: {}
    }
  },
  computed: {
    canSubmit() {
      return !!this.liveImage
    }
  },

  created() {
    let tmp = localStorage.getItem('signInfo')
    if (tmp) {
      this.signInfo = JSON.parse(tmp)
    }
  },
  methods: {
    chooseImage() {
      chooseImage({
        count: 1,
        fileMaxSize: ''
      }).then(res => {
        this.liveImage = res[0] || ''
      })
    },
    // 提交
    onSubmit() {
      // 人脸图片
      if (!this.liveImage) {
        return this.$toast('请上传人脸正面照')
      }
      let accountType = localStorage.getItem('accountType') || ''
      faceVerification({
        liveImage: this.liveImage,
        accountType: parseInt(accountType)
      }).then(res => {
        this.$toast('提交成功')
        setTimeout(() => {
          if (this.signInfo && this.signInfo.cardAndTelFlag == 1) {
            this.$router.replace({
              path: '/supply-info/bankcard'
            })
          } else {
            this.$router.replace({
              path: '/supply-info/index'
            })
          }
        }, 500)
      })
    }
  }
}
</script>
